import React from "react";
import styled from "styled-components";
import {useLocation, useNavigate} from "react-router-dom";
import {device} from "../../assets/styles/media";
import Pagination from "../molecules/Pagination";
import {faPaw} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import decodeEntities from "../../util/decodeEntities";

const ListArea = styled.div`
    margin-bottom: 100px;
    text-align: ${({category}) => !category ? "center" : "left"};

    ${device.tablet} {
        margin-top: 70px;
        margin-bottom: 50px;
        padding: 0;
    }

    ${device.mobile} {
        margin-bottom: 50px;
        margin-top: 0;
        padding: 0;
    }
`;
const Ul = styled.ul`
    display: grid;
    grid-template-columns: ${({columns}) => columns ? `repeat(${columns}, 1fr)` : "repeat(4, 1fr)"};
    justify-content: center;
    gap: ${({columns}) => columns ? '0 50px' : '0 28px'};
    max-width: 1440px;
    width: 100%;
    margin-top: -95px !important;

    ${device.tablet} {
        grid-template-columns: repeat(2, 1fr);
        gap: 40px;
        margin-top: -40px !important;
    }

    ${device.mobile} {
        grid-template-columns: repeat(2, 1fr);
        gap: 18px;
        margin-top: 0 !important;
    }

`;
const Item = styled.li`
    cursor: pointer;
    overflow: auto;
    margin-top: 90px;
    border: 1px solid #eff1f5;
    border-radius: 10px;

    ${device.tablet} {
        margin-top: 30px;
    }

    ${device.mobile} {
        margin-top: 30px;

        &:nth-child(1),
        &:nth-child(2) {
            margin-top: 0;
        }
    }
`;

const Thumb = styled.img`
    width: 100%;
    aspect-ratio: 3 / 4;
    margin-bottom: 15px;

    ${device.tablet} {
        margin-bottom: 10px;
    }
`;

const TextBox = styled.div`
    padding: 5px 20px 15px;
`;

const ListTitle = styled.strong`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
    margin-bottom: 15px;
    font-size: 20px;
    line-height: 27px;
    letter-spacing: -0.55px;
    font-weight: 800;

    ${device.tablet} {
        margin-top: 10px;
        text-align: ${({category}) => !category ? "center" : "left"};
    }

    ${device.mobile} {
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        max-width: 250px;
        text-align: ${({category}) => !category ? "center" : "left"};
        font-size: 15px;
        margin-bottom: 10px;
        white-space: break-spaces;
    }
`;
const DetailBtn = styled.span`
    position: relative;
    background-color: #e9ebf6;
    display: inline-block;
    cursor: pointer;
    padding: 7px 17px;
    border-radius: 25px;
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    color: #303537;

    ${device.mobile} {
        font-size: 12px;
    }
`;
const Category = styled.span`
    display: flex;
    align-items: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-bottom: 5px;
    color: #ed8e0c;
    font-weight: 700;

    ${device.tablet} {
        font-size: 17px;
    }
`;

const CustomIcon = styled(FontAwesomeIcon)`
    font-size: 12px;
    margin-right: 5px;

    ${device.tablet} {
        font-size: 16px;
        margin-right: 7px;
    }

    ${device.mobile} {
        font-size: 13px;
        padding-bottom: 1px;
    }
`;
const Desc = styled.span`
    font-size: 15px;
    color: #4a4a4a;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1em;
    max-height: 3em;

    ${device.tablet} {
        overflow: visible;
        text-overflow: initial;
        font-size: 20px;
        white-space: pre-wrap;
        line-height: 2rem;
        -webkit-line-clamp: unset;
        max-height: unset;
    }

    ${device.mobile} {
        font-size: 13px;
        line-height: 20px;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        padding-bottom: 0;
    }
`;

const NoList = styled.div`
    font-size: 16px;
    text-align: center;
    margin-bottom: 50px;
`;

const List = ({row, columns, pagination = true,totalPages,page,changePage}) => {
    const navigate = useNavigate();
    const {pathname} = useLocation();
    return (
        row && row.length ? (
            <ListArea category={row[0].category}>
                <Ul columns={columns}>
                    {row.map((item) => (
                        <Item key={item.postId}
                              onClick={() => {item.link? navigate(item.link) : navigate(`${pathname}/${item.postId}`)}}>
                            {item.postId && <>
                                <Thumb src={item.thumbnail} alt={item.subject}/>
                                <TextBox>
                                    {item.category &&
                                        <Category> <CustomIcon icon={faPaw}/>{item.category}</Category>}
                                    <ListTitle category={item.category}>{decodeEntities(item.subject)}</ListTitle>

                                    {item.descLine ? <Desc>{decodeEntities(item.descLine)}</Desc>
                                        : <DetailBtn>자세히보기</DetailBtn>}
                                </TextBox>
                            </>}
                        </Item>
                    ))}
                </Ul>
                {!pagination ? <></> :
                    <Pagination
                        totalPages={totalPages}
                        page={page}
                        changePage={changePage}/>}
            </ListArea>
        ) : (
            <NoList>등록된 게시물이 없습니다.</NoList>
        )
    );
};

export default List;
